import { IMatchRunPosition } from './position';

export interface IMatchRunChain {
    chainStart: number,
    path: IMatchRunPosition[],
    chainEnd: IMatchRunPosition,
    depth: number,
    averagePmpC: number,
    otoORatio: number
    ageDelta: number,
    veryLowPmpAccumulator: number,
    lowPmpAccumulator: number,
    averageCPra: number,
    maxCpra: number,
    cpr: number,
    averageHla: number,
    sumOfClcScoreEffective: number,
    longestWaitTime: number,
    waitTimeOverAYearAccumulator: number,
    acceptedPreselectStatusPercentage: number,
    bridgeDonorAbo: string,
    voucherHolderAbo: string,
    declineRatio: number,
    declineRatioCurrent: number,
    declineRatioHistoric: number,
    highestDeclineRatio: number,
    chainEndsWithViableBridgeDonor: boolean,
    numberOfSoleSourceDonors: number,
    numberOfLowRiskEpletMM: number,
    overHlaPointsFloorAccumulator: number,
    donationTypeId: number,
    donationTypeAbbreviation: string,
    patientTypeId: number,
    patientTypeAbbreviation: string,
    isSuppressibleEplet: boolean,
    isSuppressibleAge: boolean,
    isSuppressibleNonO: boolean,
    isSuppressiblePeds: boolean,
    isSuppressible: boolean,
    isKRCExcluded: boolean
}

export interface IMatchRunChainStarter {
    chainStarterId: number,
    chains: IMatchRunChain[]
}